export interface PermissionActionTypes {
  type: PermissionActions;
  payload?: any;
}

export enum PermissionActions {
  GET_PERMISSION_LIST = "GET_PERMISSION_LIST",
  SET_PERMISSION_LIST = "SET_PERMISSION_LIST",
  SET_PERMISSION_PAGE_COUNT = "SET_PERMISSION_PAGE_COUNT",
  ADD_PERMISSION = "ADD_PERMISSION",
  GET_PERMISSION_BY_USERID = "GET_PERMISSION_BY_USERID",
  SET_PERMISSION_BY_USERID = "SET_PERMISSION_BY_USERID",
  SET_PERMISSION_IN_USER = "SET_PERMISSION_IN_USER",
  GET_PERMISSION_DROPDOWN_LIST = "GET_PERMISSION_DROPDOWN_LIST",
  SET_PERMISSION_DROPDOWN_LIST = "SET_PERMISSION_DROPDOWN_LIST",
  SET_PERMISSION_DROPDOWN_LOADING = "SET_PERMISSION_DROPDOWN_LOADING"
}
